<div class="edit-zona-grupo">
  <h2>EDITAR GRUPO {{grupoSeleccionado?.nombre}}</h2>

  <div class="section-zg">
    <h3>Nombre del grupo</h3>
    <div class="displayFlexJustifyAlign">
      <input 
        class="input-edit"
        type="text"
        value={{grupoSeleccionado?.nombre}}
        [(ngModel)]="inputNameCampo"
        id="name"
      />

    </div>
  </div>

  <div class="section-zg">
    <h3>Campos grupo</h3>
    <div class="displayFlexJustify" *ngFor="let campo of campos">
      <p class="tipo-zg">{{campo.nombre}}</p>
      <span><img
        src="../../../../../../assets/trash.png"
        (click)=" handleClick(campo)"
        />
      </span> 
    </div>
    
  </div>

  <div class="section-zg">
    <h3>Nuevo campo grupo</h3>
    <div class="displayFlexJustifyAlign">
      <input class="input-tabla" type="text" id="zona" name="zona" [(ngModel)]="inputNewCampo"/>
      <button class="button__secondary btn-editar-zg" (click)="updateGrupoById()">Añadir</button>
    </div>
  </div>
  <div class="input-zg">
    <p class="tipo-zg">Seleccione las Instalaciones que desea asignar a este campo:</p>
  <mat-form-field appearance="outline">
    <mat-label>Instalaciones</mat-label>
    <mat-select multiple>
      
      <mat-checkbox (change)="selectAllInstalaciones($event.checked)" ><strong>Seleccionar Todas</strong></mat-checkbox>
      <mat-option *ngFor="let instalacion of instalaciones" [value]="instalacion.id" #matOption (click)="selectInstalacion(matOption)">{{instalacion.nombre}}</mat-option>


    </mat-select>
  </mat-form-field>
</div>
  <button class="button__primary btn-guardar-zg" (click)="updateNameGrupo(inputNameCampo)">Guardar</button>
  <button class="btn-eliminar-zg" (click)="deleteGrupoById(grupoSeleccionado.id)" >Eliminar este grupo</button>
</div>
